/* ----------------- Library Imports --------------- */
import { useAppTheme } from "@memorang/ui";
import { Platform } from "react-native";
import { TabScreen, Tabs, TabsProvider } from "react-native-paper-tabs";

interface TabData {
	label: string;
	content: React.ReactNode;
	badge?: string | number | boolean;
	icon?: string;
}
interface Props {
	tabs: TabData[];
	mode?: "scrollable" | "fixed";
	onChangeIndex?: (index: number) => void;
	backgroundColor?: string;
}
const CustomTabs = ({
	tabs,
	mode = "fixed",
	onChangeIndex,
	backgroundColor,
}: Props) => {
	const theme = useAppTheme();
	return (
		<TabsProvider onChangeIndex={onChangeIndex}>
			<Tabs
				style={{
					backgroundColor,
					...(Platform.OS === "web"
						? {
								// Inset divider shares the bottom edge with the 2px active indicator
								boxShadow: `inset 0 -1px 0 ${theme.colors.outlineVariant}`,
							}
						: {
								borderBottomWidth: 1,
								borderBottomColor: theme.colors.outlineVariant,
							}),
				}}
				mode={mode}
			>
				{tabs.map((item) => {
					return (
						<TabScreen
							badge={item.badge}
							key={item.label}
							label={item.label}
							icon={item.icon}
						>
							{item.content}
						</TabScreen>
					);
				})}
			</Tabs>
		</TabsProvider>
	);
};

export default CustomTabs;
